/* Aviso entre pantallas cuando se leen notificaciones: la pagina de notificaciones y el desplegable
   del lateral tienen cada uno su propia lista, y el lateral solo la pedia de nuevo al cambiar de pagina.
   Al marcar una como leida sin moverse de sitio, el numero del menu se quedaba igual. */
export const NOTIFICATIONS_READ_EVENT = 'tp:notifications-read';

export const notifyNotificationsRead = (ids) => {
  const keys = (Array.isArray(ids) ? ids : [ids]).filter(Boolean);
  if (keys.length === 0) return;
  window.dispatchEvent(new CustomEvent(NOTIFICATIONS_READ_EVENT, { detail: { ids: keys } }));
};

export const onNotificationsRead = (handler) => {
  window.addEventListener(NOTIFICATIONS_READ_EVENT, handler);
  return () => window.removeEventListener(NOTIFICATIONS_READ_EVENT, handler);
};
